/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IProcessConfigVersionScope extends angular.IScope {
        model: models.ProcessConfigVersionModel,
    }

    export class ProcessConfigVersionController implements IController {
        constructor(
            private scope: IProcessConfigVersionScope,
            private $rootScope: angular.IRootScopeService,
            $routeParams: angular.route.IRouteParamsService,
            $location: ng.ILocationService,
            $route: ng.route.IRouteService,
            processTypeService: services.ProcessTypeService,
            processConfigurationService: services.ProcessConfigurationService,
            deleteService: services.DeleteService,
            growl:angular.growl.IGrowlService)
        {
            var processConfigurationId = $routeParams["id"];

            this.scope.model = new models.ProcessConfigVersionModel(
                $location,
                $route,
                processTypeService,
                processConfigurationService,
                deleteService,
                processConfigurationId, () => this.sendConfigActivatedEvent(),
                growl);
        }

        private sendConfigActivatedEvent(): void {
            this.$rootScope.$broadcast('process-configuration-activated');
        }
    }
}

warsApp.registerController('ProcessConfigVersionController',
    ['$scope', '$rootScope', '$routeParams', '$location', '$route', 'processTypeService', 'processConfigurationService', 'deleteService',  'growl']);